<template>
  <main>
    <mb-panel v-if="activationCode">
      <mb-section>
        <div class="HeroContactWrapper">
          <div class="HeroContact">  
            <h1 class="HeroContact--title" v-html="$i18n.t('activationcode.page.title')">Ihr E-Banking Aktivierungscode</h1>                  
            <p class="HeroContact--lead" v-html="$i18n.t('activationcode.page.content.1')"></p>
            <p class="HeroContact--lead" v-html="$i18n.t('activationcode.page.content.2')"></p>
            <p class="HeroContact--lead" v-html="$i18n.t('activationcode.page.content.3') + '<strong>' + activationCode + '</strong> '"></p>
            <p class="HeroContact--lead" v-html="$i18n.t('activationcode.page.content.4')"></p>
            <p class="HeroContact--lead" v-html="$i18n.t('activationcode.page.content.5')"></p>
            <p class="HeroContact--lead" v-html="$i18n.t('activationcode.page.content.6')"></p>      
          </div>
        </div>
      </mb-section>
    </mb-panel>

    <div class="HeroError" v-if="!activationCode">
      <div class="HeroError--inner">
        <div class="HeroError--content">        
          <div class="HeroError--title">
            <h1 v-html="$i18n.t('requestfailed.page.title')">Vielen Dank</h1>
          </div>
          <article class="HeroError--lead">
            <p v-html="$i18n.t('requestfailed.page.content')">Besten Dank für Ihre Anfrage.</p>
          </article>           
        </div>
      </div>
    </div>     
  </main>         
</template>
<script>  
  export default {
    name: "ActivationCode",
    data() {
      return {
        activationCode: true,
      }
    },
    created() {
      if(this.$route.params.hasOwnProperty('activationCode') && this.$route.params.activationCode != '') {
        this.activationCode = this.$route.params.activationCode;
      }
    }
  }
</script>
